<template>
    <div v-can:read-tab="'programmes'">
        <div class="h2">
            Programmes
        </div>
        <hr>

        <div class="row">
            <div class="col-4">
                <base-input
                    v-model="params.scout"
                    :searching="searching"
                >
                    Rechercher (nom, ville, etc...)
                </base-input>
            </div>

            <base-select
                v-model="params.is_actif"
                :options="optionsOuiNon"
                class="col-2"
            >
                Actif
            </base-select>

            <base-select
                v-model="params.imported"
                :options="optionsOuiNon"
                class="col-2"
            >
                Importés
            </base-select>
            <div class="col-4 text-right">
                <button
                    v-can:create-model="'programme'"
                    class="btn btn-primary mt-3"
                    @click="showModal = {is_actif: 1}"
                >
                    Ajouter un programme
                </button>
            </div>
        </div>
        <form @submit.prevent="search">
            <div class="row">
                <base-select
                    v-model="params.programme_type"
                    :options="optionsProgrammeType"
                    multiple
                    class="col-2"
                >
                    Type du programme
                </base-select>

                <base-select
                    v-model="params.promoteur"
                    multiple
                    src="/api/promoteurs/autocomplete"
                    class="col-2"
                >
                    Promoteur
                </base-select>

                <base-input
                    v-model="params.date_acte_estimee_min"
                    type="date"
                    class="col-2"
                >
                    Date estimation acte après le
                </base-input>

                <base-input
                    v-model="params.date_acte_estimee_max"
                    type="date"
                    class="col-2"
                >
                    Date estimation acte avant le
                </base-input>

                <base-input
                    v-model="params.date_livraison_estimee_min"
                    type="date"
                    class="col-2"
                >
                    Date livraison après le
                </base-input>

                <base-input
                    v-model="params.date_livraison_estimee_max"
                    type="date"
                    class="col-2"
                >
                    Date livraison avant le
                </base-input>
            </div>
            <div class="row">
                <base-input
                    v-model="params.identifiant_externe"
                    type="text"
                    class="col-2"
                >
                    Identifiant Externe
                </base-input>
            </div>
            <div class="row">
                <div class="col-12 text-right">
                    <button
                        type="submit"
                        class="col-2 btn btn-success mt-3 mb-3 px-4 float-right"
                    >
                        Rechercher
                    </button>
                </div>
            </div>
        </form>

        <base-table
            :items="items"
            :meta="meta"
            :params="exParams"
            :loading="loading"
            :head="head"
            name="programme"
            class="mt-2"
            @orderBy="orderBy"
            @change-page="goToPage"
            @paginate="paginate"
            @export="exportExcel"
        >
            <tr
                v-for="programme of items"
                :key="programme.id"
            >
                <td>{{ programme.nom }}</td>
                <td v-if="programme.responsable_tva">
                    {{ programme.responsable_tva.nom }}
                </td>
                <td v-else />
                <td>{{ programme.adresse }}</td>
                <td>{{ programme.ville }}</td>
                <td>{{ programme.code_postal }}</td>
                <td>{{ programme.pays }}</td>
                <td>{{ programme.tva_solde | yesNo }}</td>

                <td class="text-right">
                    <button
                        v-can:update-model="'programme'"
                        class="btn btn-sm btn-primary mr-2"
                        title="Éditer le programme"
                        @click="showModal = programme"
                    >
                        <i class="fa fa-pen" />
                    </button>

                    <button
                        v-can:delete-model="'programme'"
                        class="btn btn-danger btn-sm mr-2"
                        title="Supprimer le programme"
                        @click="remove(programme.id)"
                    >
                        <i class="fa fa-times" />
                    </button>

                    <button
                        class="btn btn-sm btn-primary"
                        title="Chercher les doublons"
                        @click="showModalDoublon = programme"
                    >
                        <i class="fa fa-search" />
                    </button>
                </td>
            </tr>
        </base-table>

        <ProgrammeDoublonModal
            v-if="showModalDoublon !== null"
            :programme="showModalDoublon"
            :doublon-to-reload="toReload"
            @close="showModalDoublon = null"
            @reload="search()"
            @see-doublon="showModal = $event"
        />

        <ProgrammeEditModal
            v-if="showModal !== null"
            :programme="showModal"
            @reload="onReload()"
            @close="showModal = null"
        />
    </div>
</template>

<script>
    import BaseTable from "../templates/BaseTable"
    import BaseInput from "../templates/BaseInput"
    import BaseSelect from "../templates/BaseSelect"
    import ProgrammeEditModal from "../modals/ProgrammeEditModal"
    import ScoutList from "../../mixins/ScoutList"
    import ProgrammeDoublonModal from "../modals/ProgrammeDoublonModal"
    import {mapGetters} from "vuex"

    export default {
        name: "ProgrammesList",
        components: {ProgrammeDoublonModal, ProgrammeEditModal, BaseInput, BaseSelect, BaseTable},
        mixins: [ScoutList],

        url: '/api/programmes',

        data: function () {
            return {
                head: {
                    nom: "Nom",
                    responsable_tva_equipe_id: "Responsable TVA",
                    adresse: "Adresse",
                    ville: "Ville",
                    code_postal: "Code postal",
                    pays: "Pays",
                    tva_solde: "TVA soldé",
                },

                optionsOuiNon: [
                    {value: '', label: 'Tous'},
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                ],

                params: {
                    is_actif: 1,
                },

                showModalDoublon: null,

                showModalPrecisionDoublon: null,

                toReload: null,
            }
        },

        computed: {
            ...mapGetters(['optionsProgrammeType', 'me']),
        },

        methods: {
            /**
             * Exporte le tableau en xls
             */
            exportExcel: function () {
                let unique = (new Date()).getTime()
                window.open(`/api/export-excel/programmes?uniquefile=${unique}&${$.param(this.exParams)}`, '_blank')
            },

            remove: function (programmeId) {
                this.$confirm('Êtes-vous certain de vouloir supprimer ce programme ?').then(() => {
                    axios.delete(`/api/programmes/${programmeId}`)
                        .then(() => {
                            this.search()
                            this.$notify('success', 'Le programme a bien été supprimé.')
                        })
                        .catch((e) => {
                            let message = e.response.data.message ?
                                e.response.data.message :
                                'Une erreur est survenue lors de la suppression.'

                            this.$notify('danger', message)
                        })
                })
            },

            /**
             * Effectue une recherche
             */
            search: function () {
                return this.get({params: this.params})
            },

            onReload: function () {
                if (this.showModalDoublon) {
                    this.toReload = this.showModal.id
                }
                this.search()
            }
        }
    }
</script>
